import React from 'react';
import FeaturePageTemplate from '../../components/FeaturePageTemplate';

const ClosingDateFeature = () => {
  return (
    <FeaturePageTemplate
      seoKey="closingDateFeature"
      heroHeadline="Make the closing process clear for every client."
      heroSubheadline="Generate a clear closing timeline that reduces confusion instantly."
      ctaText="Create Closing Timeline"
      problemText="Clients are confused about what happens next. You spend too much time explaining the process, answering the same questions over and over."
      rootCauseText="There's no simple way to visualize the timeline."
      solutionIntro="Generate a clear closing timeline instantly."
      solutionBullets={[
        "Step-by-step breakdown",
        "Client-friendly PDF",
        "Reduces confusion",
        "Saves you time"
      ]}
      beforeItems={["Constant questions", "Confused clients", "Wasted time"]}
      afterItems={["Clear expectations", "Professional presentation", "Happy clients"]}
      proofText="Simplify the process for your clients."
    />
  );
};

export default ClosingDateFeature;
